export const HEADER_LOGO = "/ping-logo-horizontal.svg";
export const DISPLAY_NAME = "TAP AIC Pipeline";

export const menuItems = [];
